import React from "react";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Slider from "react-slick";
import './CarouselForm.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TextEvents from 'app/components/TextEvents';
import { Progress, Divider } from 'antd';



export default function CarouselForm(props) {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: (props.specialityData.length <= 2) ? props.specialityData.length : 3,
    slidesToScroll: (props.specialityData.length <= 2) ? props.specialityData.length : 3,
    autoplay: true,
    autoplaySpeed:4000
  };
  const settings2 = {
    infinite: true,
    speed: 500,
    slidesToShow: (props.systemData.length <= 2) ? props.systemData.length : 3,
    slidesToScroll: (props.systemData.length <= 2) ? props.systemData.length : 3,
    autoplay: true,
    autoplaySpeed:4000
  };

  return (
    <div >
        <Divider>
            <TextEvents
                text='Resúmen de Cumplimiento por Especialidad/Sistema:'
                color='darker'
                size='subtitle'
                weight='medium'
            />
    
        </Divider>
          <div>
              <Slider {...settings}>
                  {props.specialityData.map(i => {
                      return <Grid key={i.idSpecialty} container direction="row">
                        <Paper className={props.classes.rootCard}>
                            <Grid item xs={12} className={props.classes.paperContainerCard}>
                                <TextEvents
                                    text={`${'ESPECIALIDAD '} ${i.specialtyName} ${' ('}${i.finalized} ${'/'} ${i.total}${')'}`}
                                    color="cotemar"
                                    size='label'
                                    weight="bold"
                                />
                            </Grid>
                            <Grid item xs={12} className={props.classes.paperContainerCard}>
                                <Progress type="circle"
                                    strokeColor={{
                                        '0%': '#108ee9',
                                        '100%': '#87d068',
                                    }}
                                    percent={i.finalizedPercentage} />
                            </Grid>
                        </Paper>
                      </Grid>                      
                  })}
            </Slider>
            <Slider {...settings2}>
                  {props.systemData.map(i => {
                      return <Grid key={i.idSystem} container direction="row">
                        <Paper className={props.classes.rootCard}>
                            <Grid item xs={12} className={props.classes.paperContainerCard}>
                                <TextEvents
                                    text={`${'SISTEMA '} ${i.systemName} ${' ('}${i.finalized} ${'/'} ${i.total}${')'}`}
                                    color="cotemar"
                                    size='label'
                                    weight="bold"
                                />
                            </Grid>
                            <Grid item xs={12} className={props.classes.paperContainerCard}>
                                <Progress type="circle"
                                    strokeColor={{
                                        '0%': '#108ee9',
                                        '100%': '#87d068',
                                    }}
                                    percent={i.finalizedPercentage} />
                            </Grid>
                        </Paper>
                      </Grid>                      
                  })}
            </Slider>
        </div>
    </div>
  );
}